<template>
  <div id="header">
    <div>
      <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand href="#">
          <img src="../assets/img/vizibuzz_logo_new.png" class="" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse">
            
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <!-- <b-nav-item href="#">Link</b-nav-item>
            <b-nav-item href="#" disabled>Disabled</b-nav-item>-->
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#">Contact</b-nav-item>
            <b-nav-item href="#" class="mr-5">Help</b-nav-item>

            <div class="d-flex corner_icon">
              <b-nav-item href="#"><img src="../assets/img/trans_icon.png" class="img-fluid"></b-nav-item>
              <b-nav-item href="#"><img src="../assets/img/lang_icon.png" class="img-fluid"></b-nav-item>
              <b-nav-item href="#"><img src="../assets/img/mail_icon.png" class="img-fluid"></b-nav-item>
            </div>
            
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>
<script>
import ApiServices from "../service/ApiServices";
import swal from "sweetalert2";
export default {
  data() {
    return {
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/"
    };
  },
  methods: {
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall("api/avenir/logout", {}).then(res => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    checkCourseTest() {
      let buttonClick = localStorage.getItem("responseClick");
      //console.log(buttonClick)
      if (buttonClick == "Next") {
        Swal.fire({
          //title: 'Are you sure, you want to quit?',
          text: "Are you sure, you want to quit?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33"
        }).then(result => {
          if (result.value) {
            this.$router.push("/select-app");
          }
        });
      } else {
        this.$router.push("/select-app");
      }
    }
  },
  mounted() {
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //console.log(this.dashboardUrl)
  }
};
</script>
<style scoped lang="scss">
.navbar {
  min-height: 55px;
  background: transparent !important;
  border-color: transparent;
  border-radius: 0;
  padding-left: 25px;
  padding-right: 25px;
}
.nav-link{
    color:#000 !important;
}
</style>